import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "utils/api";
import { useFetch } from "hooks";
import { formatDate } from "utils/dates";
import { InlineWaiting } from "components/ui";

const ImportLogs = ({ patientId }) => {
  const { response, isFetching, fetchData } = useFetch({
    apiFn: patientId => get(`patients/${patientId}/logs/import`),
    defaultValue: { logs: [] }
  });

  useEffect(() => {
    fetchData(patientId);
  }, [patientId]);
  return (
    <div style={{ minHeight: 300 }}>
      <h3 style={{ textAlign: "center" }}>Import Logs</h3>
      {isFetching ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            minHeight: 300
          }}
        >
          <InlineWaiting />
        </div>
      ) : (
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <td>Date</td>
              <td>File</td>
              <td>Created By</td>
              <td>Status</td>
              <td>Error</td>
            </tr>
          </thead>
          <tbody>
            {response?.logs.map(x => (
              <tr key={x.id}>
                <td>{formatDate(x.timestamp, "MMM DD, YYYY hh:mm A")}</td>
                <td>{x.file}</td>
                <td>{x.created_by}</td>
                <td>{x.status}</td>
                <td>{x.error}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

ImportLogs.propTypes = {
  patientId: PropTypes.string.isRequired
};

export default ImportLogs;
